'use client';

import React from 'react';
import { Image } from '@nextui-org/react';
import { EyeIcon } from '@heroicons/react/24/outline';

const PreviewImage = ({
  onClick,
  ...props
}: React.ComponentProps<typeof Image>) => {
  return (
    <div className="cursor-pointer relative preview-image">
      <Image
        radius="sm"
        alt={props?.title || 'Preview Of this'}
        {...props}
        width={420}
        height={420}
        className="h-full w-full"
        classNames={{
          img: 'h-full w-full object-cover',
        }}
      />
      <div
        className="absolute top-0 text-default-800 w-full h-full flex flex-col gap-1 items-center justify-center bg-black/50 z-10 layer rounded-md "
        onClick={onClick}
      >
        <EyeIcon className="h-8 w-8 text-default-200" />
        <p className="text-default-100">View</p>
      </div>
    </div>
  );
};
export default PreviewImage;
